import React, { useState } from "react";
import { useEffect } from "react";
import {
  Box,
  Grid,
  Stack,
  Typography,
  FormControl,
  TextField,
  InputLabel,
  Divider,
  FormLabel,
  Autocomplete,
  Tooltip,
  IconButton,
  InputAdornment,
  Button,
} from "@mui/material";
import FileUpload from "./FileUploadBox.tsx";
import { FieldError } from "../../ScoreCardValidation/ValidationErrors.tsx";
import type { ValidationError } from "../../ScoreCardValidation/ValidationSchema.tsx";
import { BorderColor, Cancel, Send, UnarchiveOutlined } from "@mui/icons-material";
import CropperModal from "../../CropModel/CropperModal.tsx";
import { useSelector } from "react-redux";
import Loading from "../../Loader/Loading.tsx";
import { toast } from "react-toastify";
import { ClockIcon, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ApiCheckInCheckOutShopper } from "../../../apiService/Core/CustomApiScoreCards.tsx";

interface OtherDetailsScoreCardProps {
  invoice: any;
  setInvoice: any;
  reportDetails: any;
  uploadedFiles: Record<string, File[]>;
  onFileUpload: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,

  ) => void;
  onFileUpdate: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    index: number,
    questionId?: number,
    reportDetailId?: number
  ) => void;
  onRemoveFile: (section: string, index: number) => void;
  validationErrors?: ValidationError[];
  setArchieveImages: any;
  archieveImages: any;
  setUploadedFiles: (prevState: any) => void;
  checkOuttime: any;
  setcheckOuttime: any;
  reorderFile: (section: any, from: any, to: any, questionId: any) => void;
  date: Date | null
  reportGroup: any
  reportDetailsHeader: any
  clientEntityName: any
  moveinvoicetotaskphotos: (imgUrl: string) => void
  checkIntime: any
}

const OtherDetailsScoreCard: React.FC<OtherDetailsScoreCardProps> = ({
  invoice,
  setInvoice,
  reportDetails,
  uploadedFiles,
  onFileUpload,
  onFileUpdate,
  onRemoveFile,
  validationErrors = [],
  setArchieveImages,
  archieveImages,
  setUploadedFiles,
  checkOuttime,
  setcheckOuttime,
  reorderFile,
  date,
  reportGroup,
  reportDetailsHeader,
  clientEntityName,
  moveinvoicetotaskphotos,
  checkIntime


}) => {
  const [cropperOpen, setCropperOpen] = useState<boolean>(false);
  const [cropperFile, setCropperFile] = useState<File | null>(null);
  const [cropperSection, setCropperSection] = useState<string>("");
  const loading = useSelector((state: any) => state.loader.isLoading);
  const [selectedimage, setseletedimage] = useState<any>([])
  const [selectedmovequestion, setSelectedmovequestion] = useState<any>('')
  const [showcheckOut, setshowcheckOut] = useState<boolean>(false);
  const isAdmin = localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor'





  const handleOpenCropper = (file: File, section: string) => {
    setCropperFile(file);
    setCropperSection(section);
    setCropperOpen(true);
  };


  // Populate invoice state from reportDetails on mount
  useEffect(() => {
    if (invoice) {
      setInvoice({
        food: invoice?.food || 0,
        bar: invoice?.bar || 0,
        gaming: invoice?.gaming || 0,
        bottleshop: invoice?.bottleshop || 0,
        retail: invoice?.retail || 0,
        total: invoice?.total || 0,
      });
    }
    else if (reportDetails?.reportHeader) {
      setInvoice({
        food: reportDetails.reportHeader?.spentFoodAmt || 0,
        bar: reportDetails.reportHeader?.spentBarAmt || 0,
        gaming: reportDetails.reportHeader?.spentGamingAmt || 0,
        bottleshop: reportDetails.reportHeader?.spentBottleShopAmt || 0,
        retail: reportDetails.entityTypeDetails.entityTypeName?.toLowerCase() === "retail" ? reportDetails.reportHeader?.spentAmt : 0,
        total: reportDetails.reportHeader?.spentAmt || 0,
      });
    }
  }, [reportDetails]);

  // Handle input changes & recalculate total
  const handleInputChange = (field: "food" | "bar" | "gaming" | "bottleshop" | "retail" | "total", value: any) => {
    setInvoice((prevInvoice: any) => {
      const updatedValue = Number.parseFloat(value) || 0; // Convert to number, default to 0 if empty or invalid
      const updatedInvoice = {
        ...prevInvoice,
        [field]: updatedValue,
      };

      console.log("Feild", field)
      console.log("Value", value)
      // Calculate total using the latest numeric values
      const newTotal =
        (field === "food"
          ? updatedValue
          : Number.parseFloat(updatedInvoice.food)) +
        (field === "bar"
          ? updatedValue
          : Number.parseFloat(updatedInvoice.bar)) +
        (field === "bottleshop"
          ? updatedValue
          : Number.parseFloat(updatedInvoice.bottleshop)) +
        (field === "gaming"
          ? updatedValue
          : Number.parseFloat(updatedInvoice.gaming)) +
        (field === "retail"
          ? updatedValue
          : Number.parseFloat(updatedInvoice.retail));
      return { ...updatedInvoice, total: field === "total" ? updatedValue :newTotal.toFixed(2) }; // Ensure 2 decimal places
    });
  };





  const handleunarchieveimages = async () => {

    if (selectedimage.length > 0) {

      // setUploadedFiles((prevState: any) => {
      //   const newImageId = `${reportDetails?.reportHeader.reportHeaderId}${Date.now()}`;
      //   const taskPhotos = uploadedFiles.taskPhotos

      //   const updatedTaskPhotos = [
      //     ...taskPhotos,
      //     ...selectedimage.map(item => ({
      //       reportHdrImageId: newImageId,
      //       imageUrl: item.imageUrl
      //     }))
      //   ];
      //   return {
      //     ...prevState,
      //     taskPhotos: updatedTaskPhotos,
      //   };
      // });
      setUploadedFiles((prevState: any) => {
        // First, reorder existing photos and fix their display order sequentially
        const reorderedPhotos = (prevState.taskPhotos || [])
          .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
          .map((photo, index) => ({
            ...photo,
            displayOrder: index + 1 // Reset display order sequentially (1, 2, 3...)
          }));

        // Calculate the starting display order for new photos
        let nextDisplayOrder = reorderedPhotos.length + 1;

        // Map selected images with sequential display orders
        const newPhotos = selectedimage.map(item => {
          const newImageId = `${reportDetails?.reportHeader.reportHeaderId}${Date.now()}`;
          const photo = {
            reportHdrImageId: newImageId,
            imageUrl: item.imageUrl,
            displayOrder: nextDisplayOrder
          };
          nextDisplayOrder++; // Increment for next photo
          return photo;
        });

        // Combine reordered existing photos with new photos
        const updatedTaskPhotos = [...reorderedPhotos, ...newPhotos];

        return {
          ...prevState,
          taskPhotos: updatedTaskPhotos,
        };
      });
      setseletedimage([])
      toast.success("Images unarchived Successfully ")
    }
    else {
      toast.error("Please Select Photos")
    }
    // if (questionId) {
    //   await setAnswer((prev) => {
    //     const existingAnswer = prev[questionId] || {};
    //     return {
    //       ...prev,
    //       [questionId]: {
    //         ...existingAnswer,
    //         photoUrl: [
    //           ...(existingAnswer.photoUrl ? existingAnswer.photoUrl.split(",") : []),
    //           ...selectedimage.map((item: any) => item.imageUrl),
    //         ].join(","),
    //       },
    //     };
    //   });

    //   // await setArchieveImages((prev) => {
    //   //   prev.filter((img) => !selectedimage.includes(img.imageUrl))
    //   // })

    // }
    // else {
    //   toast.error("Please Select question label")
    // }

  }

  const handleremoveselected = (index, item) => {
    const updatedimages = selectedimage.filter((_, index2) => index2 !== index);
    setseletedimage(updatedimages);

    setArchieveImages((prev) => [...prev, item]);
  }



  const handleCheckAction = async () => {

    const confirmationMessage = "Are you sure you want to check in?"

    const userConfirmed = window.confirm(confirmationMessage);
    if (!userConfirmed) return;

    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        // const { latitude, longitude } = {};
        const params = {
          jobMonth: date && date?.getMonth() + 1,
          jobYear: date && date?.getFullYear(),
          userId: reportDetailsHeader.userId,
        };

        try {
          const payload = {
            type: "checkOut",
            shopperLatitude: position.coords.latitude,
            shopperLongitude: position.coords.longitude,
            allocationId: reportDetailsHeader.allocationId,
            platform: "web",
            platformAppType: null
          };
          // console.log("Send Data", payload)
          const response = await ApiCheckInCheckOutShopper(payload, reportGroup);
          toast.success(response.message);
          localStorage.setItem("IsCheckOutSuccessfull", "true")
        } catch (error) {
          toast.error(`Check Out failed: ${error}`);
        }
      },
      (error) => {
        console.error("Error getting location:", error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );


  };

  return (
    <Stack spacing={4}>
      {reportDetails?.reportHeader?.allocationClientGroup !== "ALDI" && (
        <>
          <Box>
            <Typography variant="h5" fontWeight={600}>
              Task Photos
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Upload your task photos here. Reports may be rejected if they fail to meet the brief photo requirements. For mystery shops, please use the crop feature to ensure we see no identifying features, e.g table number, names, clothing, your reflection/companion.
            </Typography>
          </Box>


          <FileUpload
            section="taskPhotos"
            title={`Task Photos (min ${reportDetails?.minNoOfImages} photos required)`}
            files={uploadedFiles.taskPhotos}
            reorderFile={reorderFile}
            clientGroup={reportGroup}
            onUpload={onFileUpload}
            // onUpload={(event) => {
            //   const files = event.target.files;
            //   if (!files || files.length === 0) return;
            //   const file = files[0];
            //   handleOpenCropper(file, "taskPhotos"); // pass correct section
            // }}
            setUploadedFiles={setUploadedFiles}
            onRemove={onRemoveFile}
            onUpdate={onFileUpdate}
            error={validationErrors.some((e) => e.field === "taskPhotos")}
            setArchieveImages={setArchieveImages}
            errorMessage={
              validationErrors.find((e) => e.field === "taskPhotos")?.message
            }
          />
          <FieldError errors={validationErrors} field="taskPhotos" />
          {/* {cropperOpen && cropperFile && (
            <CropperModal
              file={cropperFile}
              onClose={() => setCropperOpen(false)}
              onSave={(croppedFile) => {
                onFileUpload(
                  { target: { files: [croppedFile] } } as unknown as React.ChangeEvent<HTMLInputElement>,
                  cropperSection
                );
                setCropperOpen(false);
              }}
              reportgroup={reportGroup}

            />
          )} */}

          {reportDetails?.reportOtherDetails?.isNeedToHideInvoicePanel === 0 && (
            <Divider sx={{ mt: 2, borderBottom: '2px solid #ADB792' }} />
          )}
        </>
      )}

      {(reportDetails?.reportOtherDetails?.isNeedToHideInvoicePanel === 0) && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="h5" fontWeight={600}>
            INVOICE/RECEIPT/BANK TRANSACTION RECORD
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {/* {reportDetails?.reportHeader?.allocationClientGroup !== "MM" ? reportDetails?.reportHeader?.allocationClientGroup == "BLOOMS" ? "Please attach your receipt. Reports may be rejected without proof of purchase. Please provide all your invoice amounts here." : "Please attach your bank transaction. If, by the brief, you needed to order with m&u, please also attach the invoices emailed to you. If you conducted a report at Aria, Chophouse, Chiswick, Alegre, Bistro Grenier, Callao, North Bondi Fish, The Grounds, Coffee Factory, The Grounds of the City or Subway, you must upload receipts and bank transactions. Reports may be rejected without both of these. Kindly provide your all Invoice Amount here. Invoice photos will be great option for faster approval." : "Please attach your receipt and bank transaction. Reports may be rejected without both of these."} */}
            {reportDetails?.reportHeader?.allocationClientGroup == "BLOOMS" ? "Please attach your receipt. Reports may be rejected without proof of purchase. Please provide all your invoice amounts here." :"Please attach photos of your bank transaction for all amounts spent. If, by the brief, you needed to order via m&u or another electronic ordering system, please also attach the invoices that were emailed to you. If you conducted a report at The Grounds, Coffee Factory, The Grounds of the City, Potting Shed, Park Street Diner, Aori, Alegre, Calleo, Subway, Blooms, Fone King, Yo Chi, Top Juice, Hotel Chadstone or Allura Hair, you must upload receipts and bank transactions. Reports may be rejected without both of these."}
          </Typography>

          <Grid container spacing={2} sx={{ mt: 1 }}>
            {/* Food Amount */}
            {(reportDetails.entityTypeDetails.entityTypeName
              ?.toLowerCase()
              .includes("food")
              || reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("fb"))
              && (<Grid item xs={12} md={3}>
                <FormControl
                  fullWidth
                  error={validationErrors.some((e) => e.field === "invoice_food")}
                >
                  <FormLabel htmlFor="" sx={{ fontSize: "8px", marginBottom: '5px' }}>Food</FormLabel>
                  <TextField
                    // label="Food"
                    type="number"
                    value={invoice.food}
                    onChange={(e) =>
                      handleInputChange("food", parseFloat(e.target.value) || 0)
                    }
                    sx={{
                      "& .MuiInputBase-root": { backgroundColor: "#ffffff" },
                    }}
                    error={validationErrors.some(
                      (e) => e.field === "invoice_food"
                    )}
                  />
                  <FieldError errors={validationErrors} field="invoice_food" />
                </FormControl>
              </Grid>)}

            {/* Bar Amount */}
            {(reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("bar") || reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("fb")) && (<Grid item xs={12} md={3}>
              <FormControl
                fullWidth
                error={validationErrors.some((e) => e.field === "invoice_bar")}
              >
                <FormLabel htmlFor="" sx={{ fontSize: "8px", marginBottom: '5px' }}>Bar</FormLabel>
                <TextField
                  // label="Bar"
                  type="number"
                  value={invoice.bar}
                  onChange={(e) =>
                    handleInputChange("bar", parseFloat(e.target.value) || 0)
                  }
                  sx={{
                    "& .MuiInputBase-root": { backgroundColor: "#ffffff" },
                  }}
                  error={validationErrors.some(
                    (e) => e.field === "invoice_bar"
                  )}
                />
                <FieldError errors={validationErrors} field="invoice_bar" />
              </FormControl>
            </Grid>
            )}

            {/* BottleShop Amount */}
            {reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("bottleshop") && (<Grid item xs={12} md={3}>
              <FormControl
                fullWidth
                error={validationErrors.some(
                  (e) => e.field === "invoice_gaming"
                )}
              >
                <FormLabel htmlFor="" sx={{ fontSize: "8px", marginBottom: '5px' }}>Bottleshop</FormLabel>
                <TextField
                  label=""
                  type="number"
                  value={invoice.bottleshop}
                  onChange={(e) =>
                    handleInputChange("bottleshop", parseFloat(e.target.value) || 0)
                  }
                  sx={{
                    "& .MuiInputBase-root": { backgroundColor: "#ffffff" },
                  }}
                  error={validationErrors.some(
                    (e) => e.field === "invoice_bottleshop"
                  )}
                />
                <FieldError errors={validationErrors} field="invoice_bottleshop" />
              </FormControl>
            </Grid>
            )}
            {/* Gaming Amount */}

            {(reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("gaming") || reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("fbg")) && (<Grid item xs={12} md={3}>
              <FormControl
                fullWidth
                error={validationErrors.some(
                  (e) => e.field === "invoice_gaming"
                )}
              >
                <FormLabel htmlFor="" sx={{ fontSize: "8px", marginBottom: '5px' }}>Gaming</FormLabel>
                <TextField
                  label=""
                  type="number"
                  value={invoice.gaming}
                  onChange={(e) =>
                    handleInputChange("gaming", parseFloat(e.target.value) || 0)
                  }
                  sx={{
                    "& .MuiInputBase-root": { backgroundColor: "#ffffff" },
                  }}
                  error={validationErrors.some(
                    (e) => e.field === "invoice_gaming"
                  )}
                />
                <FieldError errors={validationErrors} field="invoice_gaming" />
              </FormControl>
            </Grid>
            )}

            {/* Retail Amount */}

            {(reportDetails.entityTypeDetails.entityTypeName?.toLowerCase() === "retail") && (
              <Grid item xs={12} md={3}>
                <FormControl
                  fullWidth
                  error={validationErrors.some(
                    (e) => e.field === "retail"
                  )}
                >
                  <FormLabel htmlFor="" sx={{ fontSize: "8px", marginBottom: '5px' }}>Spend</FormLabel>
                  <TextField
                    label=""
                    type="number"
                    value={invoice.retail}
                    onChange={(e) =>
                      handleInputChange("retail", parseFloat(e.target.value) || 0)
                    }
                    sx={{
                      "& .MuiInputBase-root": { backgroundColor: "#ffffff" },
                    }}
                    error={validationErrors.some(
                      (e) => e.field === "invoice_retail"
                    )}
                  />
                  <FieldError errors={validationErrors} field="invoice_retail" />
                </FormControl>
              </Grid>
            )}

            {/* Total Amount (Read-Only) */}
            {((reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("bottleshop") ||
              reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("fbg") ||
              reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("fb") ||
              reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("food") ||
              reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("gaming") ||
              reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("retail") ||
              reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("bar")) || reportGroup === "ALDI" || reportGroup === "BOOMS") &&

              (
                <Grid item xs={12} md={12}>
                  <FormControl
                    fullWidth
                    error={validationErrors.some(
                      (e) => e.field === "invoice_total"
                    )}
                  >
                    <FormLabel htmlFor="" sx={{ fontSize: "8px", marginBottom: '5px' }}>Total</FormLabel>
                    <TextField
                      label=""
                      type="text"
                      value={invoice.total}
                      disabled={reportGroup !== "ALDI" && reportGroup !== "BOOMS"}
                      sx={{
                        "& .MuiInputBase-root": { backgroundColor: "#f0f0f0" },
                      }}
                      onChange={(e) =>
                      handleInputChange("total", parseFloat(e.target.value) || 0)
                    }
                      error={validationErrors.some(
                        (e) => e.field === "invoice_total"
                      )}
                    />
                    <FieldError errors={validationErrors} field="invoice_total" />
                  </FormControl>
                </Grid>
              )}
          </Grid>

          {/* File Upload */}
          <Box sx={{ mt: 3 }} data-field="invoiceReceipt">
            <FileUpload
              section="invoiceReceipt"
              // title="Photo of the Outside of the Store"
              files={uploadedFiles.invoiceReceipt}
              onUpload={onFileUpload}
              reorderFile={reorderFile}
              clientGroup={reportGroup}
              // onUpload={(event) => {
              //   const files = event.target.files;
              //   if (!files || files.length === 0) return;
              //   const file = files[0];
              //   handleOpenCropper(file, "invoiceReceipt"); // pass correct section
              // }}
              setUploadedFiles={setUploadedFiles}
              onUpdate={onFileUpdate}
              onRemove={onRemoveFile}
              moveinvoicetotaskphotos={moveinvoicetotaskphotos}
              error={validationErrors.some((e) => e.field === "invoiceReceipt")}
              errorMessage={
                validationErrors.find((e) => e.field === "invoiceReceipt")
                  ?.message
              }

            />
            <FieldError errors={validationErrors} field="invoiceReceipt" />
          </Box>
          {/* {cropperOpen && cropperFile && (
            <CropperModal
              file={cropperFile}
              onClose={() => setCropperOpen(false)}
              onSave={(croppedFile) => {
                onFileUpload(
                  { target: { files: [croppedFile] } } as unknown as React.ChangeEvent<HTMLInputElement>,
                  cropperSection
                );
                setCropperOpen(false);
              }}
              reportgroup={reportGroup}
            />
          )} */}
        </Box>
      )}

      <Divider sx={{ mt: 2, borderBottom: "2px solid #ADB792" }} />

      <Box sx={{ mt: 2 }}>
        <Typography variant="h5" fontWeight={600}>
          Location Details
        </Typography>
        <Typography className="fs-16" color="text.secondary">
          Please check-out with your location, if this doesn't work please upload photo of your maps location. You will not able to proceed without one of these.
        </Typography>

        <Box className='d-flex align-items-center gap-3 ms-0 mt-3'>
          <Button
            variant="contained"
            className="custom-bg text-dark py-1 fs-16 transform text-white px-4"
            onClick={() => { handleCheckAction() }}
          >
            Check - Out with location
          </Button>
          <Typography>or</Typography>
          <Button
            variant="contained"
            className="custom-bg text-dark py-1 fs-16 transform text-white px-auto"
            onClick={() => { setshowcheckOut(true) }}
          >
            Check - Out with photo
          </Button>
        </Box>
        {(showcheckOut || validationErrors.some((e) => e.field === "checkOuttime") || validationErrors.some((e) => e.field === "checkOutFile") || uploadedFiles?.checkOutFile?.some((item: any) => item.trim() !== "")) && (
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={12}>
              <FileUpload
                section="checkOutFile"
                title="Check-Out File"
                files={uploadedFiles.checkOutFile}
                onUpload={onFileUpload}
                reorderFile={reorderFile}
                clientGroup={reportGroup}
                setUploadedFiles={setUploadedFiles}
                // onUpload={(event) => {
                //   const files = event.target.files;
                //   if (!files || files.length === 0) return;
                //   const file = files[0];
                //   handleOpenCropper(file, "checkOutFile"); // pass correct section
                // }}
                onUpdate={onFileUpdate}
                onRemove={onRemoveFile}
                error={validationErrors.some((e) => e.field === "checkOutFile")}
                errorMessage={
                  validationErrors.find((e) => e.field === "checkOutFile")
                    ?.message
                }
              />
              <FieldError errors={validationErrors} field="checkOutFile" />
              {/* {cropperOpen && cropperFile && (
                <CropperModal
                  file={cropperFile}
                  onClose={() => setCropperOpen(false)}
                  onSave={(croppedFile) => {
                    onFileUpload(
                      { target: { files: [croppedFile] } } as unknown as React.ChangeEvent<HTMLInputElement>,
                      cropperSection
                    );
                    setCropperOpen(false);
                  }}
                  reportgroup={reportGroup}
                />
              )} */}
            </Grid>

            <Grid item xs={12} md={4}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <FormControl
                  fullWidth
                // error={validationErrors.some((e) => e.field === "checkOuttime")}
                // data-field="checkOuttime"
                >
                  <InputLabel shrink={false}>
                    Date of Checkout{" "}
                    <span style={{ color: "#D32F2F" }}> *</span>
                  </InputLabel>
                  <DateTimePicker
                    value={checkOuttime ? new Date(checkOuttime) : null}
                    onChange={(newvalue) => { setcheckOuttime(newvalue) }}
                    format="dd-MM-yyyy HH:mm"
                    // minDateTime={
                    //   reportDetails?.reportHeader?.inspectionDateTime && !isAdmin
                    //     ? (() => {
                    //       const d = new Date(reportDetails.reportHeader.inspectionDateTime);
                    //       d.setHours(0, 0, 0, 0); // allow whole day
                    //       return d;
                    //     })()
                    //     : undefined
                    // }
                    minDateTime={
                      (() => {
                        // console.log('Check IN Tine', checkIntime)
                        let inspectionMin: Date | undefined;
                        if (reportDetails?.reportHeader?.inspectionDateTime && !isAdmin) {
                          inspectionMin = new Date(reportDetails.reportHeader.inspectionDateTime);
                          inspectionMin.setHours(0, 0, 0, 0); // allow whole day
                        }

                        const checkInMin = checkIntime ? new Date(checkIntime) : undefined;

                        // Checkout must be >= checkIn AND >= inspection-day start (whichever is later)
                        if (inspectionMin && checkInMin) {
                          return inspectionMin > checkInMin ? inspectionMin : checkInMin;
                        }
                        return checkInMin || inspectionMin || undefined;
                      })()
                    }
                    maxDateTime={
                      reportDetails?.reportHeader?.inspectionDateTime && !isAdmin
                        ? (() => {
                          const d = new Date(reportDetails.reportHeader.inspectionDateTime);
                          d.setHours(23, 59, 59, 999); // allow whole day
                          return d;
                        })()
                        : undefined
                    }
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: validationErrors.some((e) => e.field === "checkOuttime"),
                        helperText:
                          validationErrors.find((e) => e.field === "checkOuttime")?.message || "",
                      },

                    }}

                  // InputProps={{
                  //   endAdornment: (
                  //     <InputAdornment position="end">
                  //       <ClockIcon sx={{ color: "text.secondary" }} />
                  //     </InputAdornment>
                  //   ),
                  // }}
                  />
                  {/* <FieldError errors={validationErrors} field="checkOuttime" /> */}
                </FormControl>
              </LocalizationProvider>
            </Grid>
          </Grid>
        )}
      </Box>

      <Divider sx={{ mt: 2, borderBottom: "2px solid #ADB792" }} />

      {reportDetails?.reportHeader?.allocationClientGroup === "ALDI" && clientEntityName === 'Audit' &&
        <Box sx={{ mt: 2 }}>
          <Typography variant="h5" fontWeight={600}>
            Bag Image
          </Typography>

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <FileUpload
                section="shopperBagImages"
                title="Upload image of bag used in mysteryshop here"
                files={uploadedFiles.shopperBagImages}
                reorderFile={reorderFile}
                clientGroup={reportGroup}
                // onUpload={(event) => {
                //   const files = event.target.files;
                //   if (!files || files.length === 0) return;
                //   const file = files[0];
                //   handleOpenCropper(file, "shopperBagImages"); // pass correct section
                // }}
                onUpload={onFileUpload}
                onUpdate={onFileUpdate}
                onRemove={onRemoveFile}
                setUploadedFiles={setUploadedFiles}
                error={validationErrors.some((e) => e.field === "shopperBagImages")}
                errorMessage={
                  validationErrors.find((e) => e.field === "shopperBagImages")
                    ?.message
                }
              />
              <FieldError errors={validationErrors} field="shopperBagImages" />
              {/* {cropperOpen && cropperFile && (
                <CropperModal
                  file={cropperFile}
                  onClose={() => setCropperOpen(false)}
                  onSave={(croppedFile) => {
                    onFileUpload(
                      { target: { files: [croppedFile] } } as unknown as React.ChangeEvent<HTMLInputElement>,
                      cropperSection,
                    );
                    setCropperOpen(false);
                  }}
                  reportgroup={reportGroup}
                />
              )} */}
            </Grid>
          </Grid>

          <Divider sx={{ mt: 2, borderBottom: "2px solid #ADB792" }} />
        </Box>
      }

      {(reportDetails?.reportHeader?.allocationClientGroup !== "ALDI")
        &&
        (localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')
        && (
          <Box className='border p-3'>
            <Box className='d-flex align-items-center justify-content-between'>
              <Typography variant="h5">Archive Images</Typography>
              <Box className='d-flex align-items-center' gap={1}>
                <Tooltip title='move'>
                  <IconButton onClick={() => handleunarchieveimages()} className=""><Send /></IconButton>
                </Tooltip>
              </Box>

            </Box>
            <hr />
            {selectedimage.length > 0 && (
              <>
                <Typography>Selected Images</Typography>
                <hr className="m-0 p-0 mb-3" />
                <Grid className="w-100 mb-5" height={'50px'} spacing={1} container position={'relative'}>
                  {selectedimage?.map((item, index) => (
                    <Grid item className="h-100 image-container" position={'relative'} >
                      <Box className="h-100 border-10" width={'50px'} component={'img'} src={item?.imageUrl} key={index} />
                      <Box position={'absolute'} top={8} right={8} className='d-flex cancel-btn justify-content-center'><IconButton onClick={() => { handleremoveselected(index, item) }}><Cancel sx={{ fontSize: '18px' }} /></IconButton></Box>
                    </Grid>
                  ))}
                </Grid>
              </>

            )}
            <Grid className="w-100" spacing={2} container position={'relative'}>
              {archieveImages?.map((item, index) => (
                <Grid item >
                  <Box height={'fit-content'}>
                    <Box height={125} width={150} className='border border-10'>
                      <Box className="w-100 border-10" component={'img'} style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }} src={item.imageUrl} key={index} />
                    </Box>
                    <Box className='d-flex justify-content-center mt-4'>
                      <Tooltip title='unarchive'>
                        <IconButton
                          onClick={() => {
                            setseletedimage((prev) => [...prev, item]);
                            setArchieveImages((prev) =>
                              prev.filter((question) => question.imageUrl !== item.imageUrl)
                            );
                          }}><UnarchiveOutlined /></IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        )}
      {/* {loading && localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor' && <Loading />} */}
    </Stack>
  );
};

export default OtherDetailsScoreCard;
